import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import VConsole from 'vconsole'
const root = ReactDOM.createRoot(document.getElementById('root'))

if (process.env.NODE_ENV === 'development') {
  sessionStorage.setItem('userInfo', JSON.stringify({
    openId: "o5u_6sl6MooG9dj0xGDC_zqwWExc",
    nickName: "Kkk",
    email: "pwkzyy@163.com",
    headImgUrl:
      "https://thirdwx.qlogo.cn/mmopen/vi_32/ZB6wONn1rdQWmldYfHhuFFgONVLugSex2uAvwiaNB4XMibXjrzmBv3N3iapiaPABeMUExmGC0ft9FlxSNDbkyEkOCV8ZuFYWbyawnRTS8avLia30/132",
  }))
}

// const vConsole = new VConsole()

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
